export default "__VITE_ASSET__BdlOfy$4__"